import { useState } from "react";
import { categories } from "@/mocks/comicData";

export default function Categories() {
  const [activeId, setActiveId] = useState(categories[0].id);
  const active = categories.find((c) => c.id === activeId) || categories[0];

  return (
    <section id="category" className="bg-background-100/60 py-14 md:py-20">
      <div className="section-x">
        <div className="mx-auto max-w-2xl text-center">
          <p className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-700">
            <span className="h-2 w-2 rounded-full bg-primary-500"></span>
            漫画分类专区
          </p>
          <h2 className="mt-2 font-heading text-3xl text-foreground-900 md:text-4xl">挑一个你喜欢的漫画类型</h2>
          <p className="mt-3 text-foreground-600">
            从热血国漫到经典日漫，从韩漫条漫到美式漫画，点选分类查看题材特色与阅读建议。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-[1fr_1.3fr]">
          <div className="flex flex-col gap-3">
            {categories.map((cat) => {
              const activeTab = cat.id === activeId;
              return (
                <button
                  key={cat.id}
                  type="button"
                  onClick={() => setActiveId(cat.id)}
                  className={`flex cursor-pointer items-center gap-4 rounded-lg border p-4 text-left transition-colors ${
                    activeTab
                      ? "border-primary-300 bg-primary-50"
                      : "border-background-200/70 bg-background-50 hover:border-primary-200"
                  }`}
                >
                  <span
                    className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg ${
                      activeTab ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-700"
                    }`}
                  >
                    <i className={`${cat.icon} text-xl`}></i>
                  </span>
                  <span className="flex-1">
                    <span className="flex items-center gap-2 text-lg font-semibold text-foreground-900">
                      {cat.name}
                      <span className="text-xs font-normal text-foreground-400">{cat.en}</span>
                    </span>
                    <span className="mt-0.5 block text-sm text-foreground-600">{cat.desc}</span>
                  </span>
                  <span
                    className={`hidden shrink-0 rounded-full px-3 py-1 text-xs sm:inline-flex ${
                      activeTab ? "bg-primary-100 text-primary-800" : "bg-secondary-100 text-secondary-700"
                    }`}
                  >
                    {cat.count}
                  </span>
                </button>
              );
            })}
          </div>

          <div className="overflow-hidden rounded-lg border border-background-200/70 bg-background-50">
            <div className="relative h-60 w-full md:h-72">
              <img
                src={active.image}
                alt={`${active.name}漫画分类封面`}
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/55 to-transparent"></div>
              <div className="absolute bottom-4 left-5">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className={`${active.icon} text-2xl`}></i>
                </span>
                <h3 className="mt-2 font-heading text-3xl text-background-50">{active.name}漫画</h3>
              </div>
            </div>
            <div className="p-6">
              <p className="leading-relaxed text-foreground-700">
                {active.desc} 在主流正版平台中，{active.name}漫画题材选择丰富，既有适合入门的口碑之作，也有满足深度读者的连载神作，可通过上方榜单中的推荐平台按需追更。
              </p>
              <div className="mt-5 flex flex-wrap items-center gap-3 border-t border-background-200/70 pt-4">
                <span className="text-sm text-foreground-500">收录数量：</span>
                <span className="rounded-full bg-accent-100 px-3 py-1 text-sm text-accent-800">{active.count}</span>
                <button
                  type="button"
                  onClick={() => document.querySelector("#ranking")?.scrollIntoView({ behavior: "smooth" })}
                  className="ml-auto cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm text-background-50 hover:bg-primary-600"
                >
                  去榜单挑选
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}